import React, { useState } from 'react';
import { Popover, PopoverBody } from 'reactstrap';

const baseBadgeStyle = {
    padding: '3px 8px', 
    borderRadius: '10px', 
    color: 'white',
    fontSize: '11px', 
    fontWeight: 'bold',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px', 
};

const existsStyle = { ...baseBadgeStyle, backgroundColor: '#28a745' }; 
const notExistStyle = { ...baseBadgeStyle, backgroundColor: '#dc3545' }; 
const iconStyle = { cursor: 'pointer', fontSize: '12px' }; 

const StatusCell = ({ dataItem, GA }) => {
    const statusKey = GA ? 'GENERAL_AVAILABILITY_STATUS' : 'CERT_LIST_STATUS';
    const statusString = dataItem[statusKey];
    const greenMessage = GA ? 'GA Created' : "CT Created";
    const redMessage = GA ? 'GA Not Created' : "CT Not Created";

    const cleanId = dataItem.ANNOUNCEMENT_ID.trim();
    const popoverTargetId = `status-popover-${cleanId}`;

    const [isPopoverOpen, setPopoverOpen] = useState(false);
    const togglePopover = () => setPopoverOpen(!isPopoverOpen);
    
    const hasValue = statusString && statusString.trim() !== '';

    if (hasValue) {
        const listItems = statusString.split(',').map((item, index) => (
            <li key={index}>{item.trim()}</li>
        ));

        return (
            <span style={existsStyle}>
                {greenMessage}
                <span id={popoverTargetId} className="k-icon k-i-information" style={iconStyle}></span>
                <Popover
                    placement="top"
                    isOpen={isPopoverOpen}
                    target={popoverTargetId}
                    toggle={togglePopover}
                    trigger="legacy"
                >
                    <PopoverBody>
                        <ol style={{ margin: 0, paddingLeft: '20px', fontSize: '12px' }}>
                            <b>{listItems}</b>
                        </ol>
                    </PopoverBody>
                </Popover>
            </span>
        );
    }
    
    return (
        <span style={notExistStyle}>
            {redMessage}
        </span>
    );
};

export default StatusCell;